import { FlexRow, IconButton } from 'components/lib'
import React from 'react'
import { MdClose } from 'react-icons/md'
import styled from 'styled-components/macro'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  background-color: ${props => props.theme.colors.bg0};
  height: 100%;
  justify-content: center;
`

const ContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 480px;
`

const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
`

const ContainerTextTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 44px;
  text-align: center;
  letter-spacing: -0.02em;
  color: ${props => props.theme.colors.text100};
`

const ContainerTextDescription = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${props => props.theme.colors.text100};
`

const ContainerTextLink = styled.a`
  font-style: inherit;
  font-weight: 500;
  font-size: inherit;
  line-height: inherit;
  text-align: inherit;
  color: inherit;
  text-decoration: underline;
`

const AnnouncementNotFound = ({
  onRequestClose,
}: {
  onRequestClose: Function
}) => (
  <Container>
    <FlexRow
      align="center"
      justify="flex-end"
      style={{ position: 'absolute', top: 16, right: 16 }}
    >
      <IconButton onClick={event => onRequestClose(event)}>
        <MdClose />
      </IconButton>
    </FlexRow>
    <ContainerBody>
      <ContainerContent>
        <ContainerText>
          <ContainerTextTitle>Announcement not found</ContainerTextTitle>
          <ContainerTextDescription>
            Hmm, the announcement you’re looking for doesn’t exist. If you think
            you received this message in error, please{' '}
            <ContainerTextLink href="mailto:help@hiresuper.com?subject=404">
              contact Super
            </ContainerTextLink>
            .
          </ContainerTextDescription>
        </ContainerText>
      </ContainerContent>
    </ContainerBody>
  </Container>
)

export default AnnouncementNotFound
